import React from 'react';
import { PropTypes } from 'mobx-react';
import Button from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';
import './AlarmList.css';

import { observer } from 'mobx-react';

import {
  getShortDayNameFromDayNumber
} from '../../utils/datetime';

const propTypes = {
  alarms: PropTypes.observableArrayOf(React.PropTypes.shape({
    timeString12Hours: React.PropTypes.string.isRequired,
    timePeriod: React.PropTypes.string.isRequired,
    id: React.PropTypes.number.isRequired,
    is_active: React.PropTypes.bool,
    days: PropTypes.observableArray
  })),
  onEditClick: React.PropTypes.func.isRequired
}

const AlarmList = props => (
  <ul className={`alarm-list u-no-shrink`}>
    {props.alarms ? props.alarms.map(alarm => (
      <li className='alarm-list__item' key={alarm.id} onClick={() => {
        props.onEditClick(alarm.id);
      }}>
        <div className='alarm-list__item-state' onClick={(e) => {
          e.stopPropagation();
        }}>
          <Checkbox
            id={`alarm_${alarm.id}`}
            checked={alarm.is_active}
            onChange={() => {
              props.onActiveStateClick(alarm);
            }}
          />
        </div>
        <div className='alarm-list__item-time'>
          <span className='alarm-list__item-hour'>
            {alarm.timeString12Hours}
          </span>
          <span className='alarm-list__item-period'>
            {alarm.timePeriod}
          </span>
        </div>
        <div className='alarm-list__item-repeat'>
          {alarm.days && alarm.days.length ?
            alarm.days.map(day => getShortDayNameFromDayNumber(day - 1)).join(', ')
          : 'No Repeat'}
        </div>
        <div className='alarm-list__item-edit'>
          <Button type='outline' size='sm' onClick={() => {
            props.onEditClick(alarm.id);
          }}>
            Edit
          </Button>
        </div>
      </li>
    )) : null}
  </ul>
)

AlarmList.propTypes = propTypes;

export default observer(AlarmList);



// WEBPACK FOOTER //
// ./src/components/AlarmList/AlarmList.js